import { render, staticRenderFns } from "./HomeworkViewer.vue?vue&type=template&id=89926d0a&"
import script from "./HomeworkViewer.vue?vue&type=script&lang=js&"
export * from "./HomeworkViewer.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports